import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import {source_tags} from "./dummyData"
import SourceTagsTableData from "./SourceTagsTableData";
import { SearchIcon } from "lucide-react";
import server from "../../utils/serverConfig";

export default function SourceTagsComponent() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchSourceTags = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}source-tags`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response data-------------->", response.data);
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchSourceTags();
  }, []);

  // Filter data based on search query
  const filteredData = data.filter((item) =>
    item.sources.some((source) =>
      source.replace(/\s+/g, "").toLowerCase().includes(searchQuery.replace(/\s+/g, "").toLowerCase())
    )
  );
  

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        <div className="flex items-center justify-between space-x-4 ">
          
          <div className="flex items-center justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
            <p className="flex items-center text-lg font-semibold text-white">
            Source Tags Data Table
            </p>
            <div className="flex items-center space-x-1 bg-zinc-900  px-4">
              <SearchIcon className="h-5 w-5 text-white" />
              <input
              type="text"
              className="bg-zinc-900 text-white rounded px-4 py-3 text-sm focus:outline-none"
              placeholder="Search by Source"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            </div>
          </div>
        </div>

        <div className="w-full h-full overflow-hidden ">
          <SourceTagsTableData data={filteredData} />
        </div>
      </div>
    </DashboardLayout>
  );
}
